// my-preset.ts
import { definePreset } from '@primeuix/themes';
// v22 の nora は 16px 基準で余白が詰まった。v19 と同じ寸法を保つ compat 版を使う
import Nora from '@primeuix/themes/nora-compat';

const Preset = definePreset(Nora, {
  semantic: {
    primary: {
      50: '{blue.50}',
      100: '{blue.100}',
      200: '{blue.200}',
      300: '{blue.300}',
      400: '{blue.400}',
      500: '{blue.500}',
      600: '{blue.600}',
      700: '{blue.700}',
      800: '{blue.800}',
      900: '{blue.900}',
      950: '{blue.950}',
    },
    // v22 は select のラベルや選択肢などが typography.fontSize（1rem）固定になり、
    // styles.scss の .p-component { font-size: 90% } が効かなくなった。v19 と同じく親の文字サイズを継承させる
    typography: {
      fontSize: '1em',
    },
  },
});

export default Preset;
